import { axiosInstance } from "../../utility/apiInstance";
import { StatusFilter, TemplatePayload } from "./communicationTemplate.types";

const AIRBASE = "/api/v1/communication-templete";
const OCEANBASE = "/api/v1/ocean-communication-templete";

const baseFor = (mode: string) => (mode === "air" ? AIRBASE : OCEANBASE);

export const fetchTemplates = async (search = "", status: StatusFilter = "all", mode: string) => {
    const BASE = baseFor(mode);
    const params = new URLSearchParams();
    if (search) params.set("search", search);
    if (status && status !== "all") params.set("status", status);
    const res = await axiosInstance.get(`${BASE}?${params.toString()}`);
    return res.data?.data || [];
};

// Mode-based
export const fetchMilestones = async (mode: string) => {
    const path = mode === "air" ? "/api/v1/mileStone" : "/api/v1/ocean/ocean-milestone";
    const res = await axiosInstance.get(path);
    const data = mode === "air" ? res?.data || [] : res?.data?.data || [];
    return data;
};

export const fetchFlags = async () => {
    const { data } = await axiosInstance.get("/api/v1/flags");
    const list = Array.isArray(data) ? data : data?.data || [];
    return list
        .filter((flag: any) => flag.status === "Active")
        .map((flag: any) => ({
            ...flag,
            _id: flag.id,
        }));
};
export const createTemplate = (payload: TemplatePayload, mode: string) =>
    axiosInstance.post(baseFor(mode), payload);

export const updateTemplate = (id: string | number, payload: TemplatePayload, mode: string) =>
    axiosInstance.patch(`${baseFor(mode)}/${id}`, payload);

export const deleteTemplate = (id: string | number, mode: string) =>
    axiosInstance.delete(`${baseFor(mode)}/${id}`);

export const previewTemplate = (
    payload: { emailMilestones: any[]; waMilestones: any[] },
    mode: string
) => axiosInstance.post(`${baseFor(mode)}/preview`, payload);